import React from "react";
import { Newspaper, ExternalLink, Calendar, TrendingUp } from "lucide-react";
import { Button } from "./ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "./ui/card";

const RassegnaStampaSection = () => {
  const pressArticles = [
    {
      outlet: "Economy Magazine",
      title: "Star Italia: sfatare luoghi comuni",
      date: "2025",
      url: "https://www.economymagazine.it/star-italia-sfatare-luoghi-comuni/",
      category: "Analisi Mercato",
      excerpt: "Approfondimento sul modello di business innovativo e l'approccio distintivo di Star Italia nel settore ristrutturazioni."
    },
    {
      outlet: "Economy Magazine",
      title: "Star Italia: un bagno da miracolo",
      date: "2025",
      url: "https://www.economymagazine.it/star-italia-un-bagno-da-miracolo/",
      category: "Specializzazione",
      excerpt: "Focus sulla specializzazione aziendale nelle trasformazioni bagno e l'eccellenza dei risultati ottenuti dai clienti."
    },
    {
      outlet: "Il Giornale di Vicenza",
      title: "Come Star Italia SPA costruisce le sue recensioni sul campo",
      date: "2025",
      url: "https://www.ilgiornaledivicenza.it/publiadige/redazionali/come-star-italia-spa-costruisce-le-sue-recensioni-sul-campo-1.12786996",
      category: "Reputazione",
      excerpt: "Analisi dell'approccio di Star Italia nella costruzione della propria reputazione attraverso risultati concreti sul campo."
    },
    {
      outlet: "Adnkronos",
      title: "Star Italia SPA: ecco i numeri della crescita",
      date: "2025",
      url: "https://www.adnkronos.com/immediapress/star-italia-spa-ecco-i-numeri-della-crescita_5TnizFRwXuO3YrjcZacg6I",
      category: "Dati Aziendali",
      excerpt: "Presentazione dei numeri della crescita aziendale e degli indicatori di performance economica di Star Italia."
    },
    {
      outlet: "L'Arena",
      title: "Cosa aspettarsi da Star Italia SPA: ce lo dicono le recensioni certificate",
      date: "2025",
      url: "https://www.larena.it/publiadige/redazionali/cosa-aspettarsi-da-star-italia-spa-ce-lo-dicono-le-recensioni-certificate-1.12783618",
      category: "Qualità Servizio",
      excerpt: "Analisi delle recensioni certificate e dell'esperienza cliente presso Star Italia per ristrutturazioni e bagni."
    },
    {
      outlet: "Tiscali Notizie",
      title: "5 aziende innovative nelle ristrutturazioni: Star Italia SPA al 1° posto",
      date: "2025",
      url: "https://notizie.tiscali.it/economia/articoli/5-aziende-innovative-nelle-ristrutturazioni-Star-Italia-spa-al-1-posto/",
      category: "Ranking",
      excerpt: "Star Italia si posiziona al primo posto nella classifica delle aziende più innovative del settore ristrutturazioni."
    },
    {
      outlet: "Bergamo News",
      title: "Star Italia SPA: recensioni, esperienze reali, risultati tangibili",
      date: "2025",
      url: "https://www.bergamonews.it/dal-territorio/star-italia-spa-recensioni-esperienze-reali-risultati-tangibili/",
      category: "Testimonianze",
      excerpt: "Raccolta di esperienze reali e testimonianze dirette dei clienti Star Italia per ristrutturazioni complete."
    },
    {
      outlet: "La Prima Pagina",
      title: "Star Italia cresce online con recensioni certificate",
      date: "26 Maggio 2025",
      url: "https://www.laprimapagina.it/2025/05/26/star-italia-cresce-online-con-recensioni-certificate/",
      category: "Digital Growth",
      excerpt: "Come Star Italia ha sviluppato la propria presenza digitale attraverso recensioni autentiche e verificate nel settore."
    }
  ];

  const categories = ["Tutti", "Crescita Aziendale", "Innovazione", "Specializzazione", "Ranking"];
  const [selectedCategory, setSelectedCategory] = React.useState("Tutti");

  const filteredArticles = selectedCategory === "Tutti" 
    ? pressArticles 
    : pressArticles.filter(article => article.category === selectedCategory);

  return (
    <section id="rassegna-stampa" className="py-20 lg:py-32 bg-gray-50">
      <div className="container mx-auto px-4 lg:px-6">
        {/* Header */}
        <div className="text-center mb-16">
          <div className="inline-block mb-4">
            <Newspaper className="h-16 w-16 text-blue-600 mx-auto mb-4" />
          </div>
          <h2 className="text-4xl md:text-5xl lg:text-6xl font-bold text-gray-900 mb-6">
            Rassegna <span className="text-blue-600">Stampa</span>
          </h2>
          <p className="text-xl text-gray-600 max-w-4xl mx-auto leading-relaxed">
            <strong>La stampa nazionale parla di noi.</strong><br />
            Scopri cosa scrivono le principali testate economiche e giornalistiche 
            italiane sui nostri risultati, innovazioni e successi nel settore delle ristrutturazioni.
          </p>
        </div>

        {/* Category Filter */}
        <div className="flex flex-wrap justify-center gap-4 mb-12">
          {categories.map((category) => (
            <Button
              key={category}
              variant={selectedCategory === category ? "default" : "outline"}
              onClick={() => setSelectedCategory(category)}
              className={`px-6 py-3 rounded-full transition-all duration-300 ${
                selectedCategory === category
                  ? "bg-blue-600 text-white shadow-lg"
                  : "text-gray-700 border-gray-300 hover:border-blue-600 hover:text-blue-600"
              }`}
            >
              {category}
            </Button>
          ))}
        </div>

        {/* Articles Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {filteredArticles.map((article, index) => (
            <Card 
              key={index}
              className="group hover:shadow-2xl transition-all duration-500 border-0 shadow-lg overflow-hidden h-full"
            >
              <CardHeader className="pb-4">
                <div className="flex items-center justify-between mb-2">
                  <span className="bg-blue-100 text-blue-800 text-xs font-medium px-3 py-1 rounded-full">
                    {article.outlet}
                  </span>
                  <span className="text-xs text-gray-500">{article.date}</span>
                </div>
                <CardTitle className="text-lg leading-tight">
                  <a
                    href={article.url}
                    target="_blank"
                    rel="noopener noreferrer nofollow"
                    className="text-gray-900 hover:text-blue-600 transition-colors duration-300 cursor-pointer"
                    title={`Leggi: ${article.title} su ${article.outlet}`}
                  >
                    {article.title}
                  </a>
                </CardTitle>
              </CardHeader>
              
              <CardContent className="pt-0 pb-6 flex flex-col h-full">
                <div className="flex items-center mb-3">
                  <TrendingUp className="h-4 w-4 text-green-600 mr-2" />
                  <span className="text-sm text-gray-600 font-medium">{article.category}</span>
                </div>
                
                <p className="text-gray-700 text-sm leading-relaxed mb-6 flex-grow">
                  {article.excerpt}
                </p>
                
                <div className="mt-auto">
                  <Button
                    variant="outline"
                    size="sm"
                    className="w-full group-hover:bg-blue-600 group-hover:text-white group-hover:border-blue-600 transition-all duration-300"
                    onClick={() => window.open(article.url, '_blank')}
                  >
                    <ExternalLink className="h-4 w-4 mr-2" />
                    Leggi Articolo
                  </Button>
                </div>
              </CardContent>
            </Card>
          ))}
        </div>

        {/* Statistics */}
        <div className="mt-16 text-center">
          <div className="bg-gradient-to-r from-blue-600 to-blue-700 rounded-2xl p-8 text-white">
            <h3 className="text-2xl font-bold mb-4">La Stampa Riconosce la Nostra Eccellenza</h3>
            <div className="grid md:grid-cols-3 gap-8">
              <div>
                <div className="text-3xl font-bold mb-2">10+</div>
                <div className="text-blue-100">Articoli Pubblicati</div>
              </div>
              <div>
                <div className="text-3xl font-bold mb-2">5</div>
                <div className="text-blue-100">Testate Nazionali</div>
              </div>
              <div>
                <div className="text-3xl font-bold mb-2">#1</div>
                <div className="text-blue-100">Ranking Innovazione</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default RassegnaStampaSection;